import { Component, ViewChild, OnInit, ElementRef, Renderer2 } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Response } from '@angular/http';
import { NgForm, FormControl, FormGroup, FormBuilder } from '@angular/forms';

import { NavigationService } from '../../shared-services/navigation.service';
import { SnackService } from '../../shared-services/snack.service';
import { BackendService } from '../../core/backend.service';
import { DialogService } from '../../shared-components/modals/dialog.service';
import { FormValidatorService } from '../../shared-services/form-validator.service';
import { Producto } from '../producto.model';
import { MedidasProducto } from '../medidas-producto.model';
import { Imagen } from '../imagen.model';
import { CategoriaProducto } from '../categoria-producto/categoria-producto.model';
import { Observable } from 'rxjs/Observable';
import { SubcategoriaProducto } from '../subcategoria-producto/subcategoria-producto.model';
import { Proveedor } from '../proveedor/proveedor.model';
import { ApiService } from '../../core/api.service';
import { Sugerencia } from '../sugerencia/sugerencia.model';
import { MatAutocompleteSelectedEvent, MatChipInputEvent } from '@angular/material';
import { ENTER } from '@angular/cdk/keycodes';
import { Parametric } from '../parametric.model';
import { Talle } from '../talle/talle.model';
import { OperationalParametric } from '../../cliente/operationalParametric.model';
import { Cliente } from '../../cliente/cliente.model';
import { Color } from '../color/color.model';
import { TipoImpresion } from '../tipo-impresion/tipo-impresion.model';
import { HttpClient } from '@angular/common/http';
import { ProveedorSimple } from '../modificacion-precio/proovedor-simple.model';
import { ProductoSimple } from '../producto-simple.model';
import { SecurityService } from '../../security/security.service';
import { Role } from '../../security/role/role.model';

@Component({
  selector: 'app-producto-add-edit',
  templateUrl: './producto-add-edit.component.html',
  styleUrls: ['./producto-add-edit.component.scss']
})
export class ProductoAddEditComponent implements OnInit {
  @ViewChild('form') public productoForm: NgForm;

  producto: Producto;
  productoSimple:ProductoSimple;
  private imagenes: Imagen[];
  validationFail = false;
  selected = new FormControl(0);
  separatorKeysCodes: number[] = [ENTER];
  paises: string[] = [ "ARGENTINA","CHILE"];
  public editorOptions = {
    placeholder: 'Ingrese texto formateado para la descripción técnica'
  };
  proveedorCargado: Proveedor;

  sugerencias: Observable<Sugerencia[]>;
  categorias: Observable<CategoriaProducto[]>;
  subcategorias: Observable<SubcategoriaProducto[]>;
  clientes: Observable<Cliente[]>;
  colores: Observable<Color[]>;
  talles: Observable<Talle[]>;

  categoriasInternas: CategoriaProducto[];
  categoriasExternas: CategoriaProducto[];
  subcategoriasInternas: SubcategoriaProducto[];
  subcategoriasExternas: SubcategoriaProducto[];
  sugerenciasInternas: Sugerencia[];
  sugerenciasExternas: Sugerencia[];

  proovedores: Proveedor[]=[];
  proveedorId: number;
  numberPaisId: number = 0;
  proveedorSimple: ProveedorSimple;

  cambiaProveedor: boolean = false;
  nombrePais: string;
  talleDesde: number;
  talleHasta: number;
  intervalo: number;
  tipoTalle: string;
  tallesNumericos: OperationalParametric[] = [];
  tiposImagenes: Observable<OperationalParametric[]>;
  tiposImpresion: Observable<TipoImpresion[]>;

  categoriasFail = false;
  totalTalles: number;
  imagenFile: File;
  imagenesFile: File[]=[];

  user: any;
  rol: Role;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private navigationService: NavigationService,
    private snackService: SnackService,
    private backendService: BackendService,
    private dialogService: DialogService,
    private apiService: ApiService,
    private formValidatorService: FormValidatorService,
    private authService: SecurityService
  ) { }

  ngOnInit() {

    this.user = this.authService.user;

    this.getTalles();
    this.getColores();
    this.getCategorias();
    this.getSubcategorias();
    this.getClientes();
    this.getTiposImagenes();
    this.getTiposImpresion();
    this.getProveedores();
    this.getRol();  
    

    this.route.data.subscribe(data => {
      this.producto = data.user;
      this.producto.pais = this.producto.pais ? this.producto.pais : '';
      this.producto.activo = this.producto.activo === undefined ? 'true' : this.producto.activo;
      this.producto.categorias = this.producto.categorias ? this.producto.categorias : [];
      this.producto.subcategorias = this.producto.subcategorias ? this.producto.subcategorias : [];
      this.producto.imagenes = this.producto.imagenes ? this.producto.imagenes : [];
      this.producto.imagenesPersonalizables = this.producto.imagenesPersonalizables ? this.producto.imagenesPersonalizables : [];

      this.producto.colores = this.producto.colores ? this.producto.colores : [];
      this.producto.talles = this.producto.talles ? this.producto.talles : [];
      this.producto.medidas = this.producto.medidas ? this.producto.medidas : new MedidasProducto();
      this.producto.cliente = this.producto.cliente ? this.producto.cliente : this.backendService.new(Cliente);
      this.producto.tallesNumericos = this.producto.tallesNumericos ? this.producto.tallesNumericos : [];
      this.producto.proveedor =this.producto.proveedor;
      if (this.producto.tallesNumericos && this.producto.tallesNumericos.length > 0) {
        this.tipoTalle = '1';
      } else if (this.producto.talles &&  this.producto.talles.length > 0) {
        this.tipoTalle = '2';
      }
    });
    this.getIdPais();
    this.getNombrePais();
  }

  generarTalles() {
    this.dialogService.confirm('Creación de talles numéricos',
      '¿Está seguro que desea regenerar los talles numéricos, se perderán los talles actuales ?')
      .then( res => {
        if (res) {
          this.tallesNumericos.splice(0);
          this.producto.tallesNumericos.splice(0);
          for (let i = this.talleDesde; i <= this.talleHasta; i += this.intervalo) {
            const t = new OperationalParametric();
            t.id = i;
            t.description = i.toString();
            this.tallesNumericos.push(t);
            this.producto.tallesNumericos.push(t);
          }
        }
      });
  }

  hayDatosExternos() {
    return (this.categoriasExternas && this.categoriasExternas.length > 0) ||
            (this.subcategoriasExternas && this.subcategoriasExternas.length > 0) ||
            (this.sugerenciasExternas && this.sugerenciasExternas.length > 0);
  }

  async getCategorias() {
    this.categorias = this.backendService.get(CategoriaProducto, CategoriaProducto.path + 'todos', {});
  }
  async getSubcategorias() {
    this.subcategorias = this.backendService.get(SubcategoriaProducto, SubcategoriaProducto.path, {});
  }
  async getColores() {
    
    this.colores = this.backendService.get(Color, Color.path + 'todos', {});
    /*this.backendService.get(Parametric, Color.path + 'todos',null).toPromise().then(a =>{
      this.colores = a;
    });*/
  }

  async getProveedores(){
    this.proovedores = await this.backendService.get(Proveedor,"/new-productos/proveedores-completos",null).toPromise();
  }

  async getClientes() {
    this.clientes = this.backendService.get(Cliente, Cliente.path, {});
  }
  async getTalles() {
    this.talles = this.backendService.get(Talle, Talle.path, null);
    this.talles.subscribe(talles => this.totalTalles = talles.length);
  }
  async getTiposImagenes() {
    this.tiposImagenes = await this.apiService.get(Parametric, Parametric.path + 'tipos_imagenes/', null);
  }

  async getTiposImpresion() {
    this.tiposImpresion = this.backendService.get(TipoImpresion, TipoImpresion.path, {});
  }

  back() {
    this.router.navigate(['/productos']);
  }

  async confirmSave() {
    if (this.validateForm()) {
      //if (this.validarColores()) {

        if(this.producto.categorias.length == 0){
          this.snackService.error('Debe cargar al menos una categoria.');
          return
        }
        if(this.producto.colores.length == 0){
          this.snackService.error('Debe cargar al menos un color.');
          return
        }
        if(!this.producto.id){
          if(this.producto.imagenes[0].file == undefined){
            this.snackService.error('Debe cargar al menos una imagen.');
            return
          }
        }
          

        this.dialogService.confirm(this.producto.id ? 'Edición de producto' : 'Alta de producto',
        '¿Está seguro que desea guardar el producto ' + this.producto.nombre + '?')
        .then( res => {
          if (res) {
            this.save(res);
          }
        });
      /*} else {
        this.snackService.error('Debe ingresar al menos una foto por color de producto');
      }*/
    }
  }

  onProvSelect(event){
    this.producto.proveedor = event.value;
    //this.proveedorId = this.producto.proveedor.id;
  }

  onProvSelectConProveedor(event){
    this.producto.proveedor = event.value;
    this.cambiaProveedor = true;
    //this.proveedorId = this.producto.proveedor.id;
    
  }

  validateForm() {
    let validationsOK = false;
    // Valida el resto de los controles con sus validadores
    if (!this.formValidatorService.isFormValid(this.productoForm)
      || this.producto.categorias === undefined){
      //|| !this.validarImagenes(this.producto)) {
      validationsOK = false;
      this.validationFail = true;
    } else {
      validationsOK = true;
      this.validationFail = false;
    }

    return validationsOK;
  }

  validarImagenes(prod: Producto) {
    if (prod.imagenes.length === 0) {
      this.snackService.error('Debe cargar al menos una imágen.');
      return false;
    }

    /*if (prod.imagenes.some(i => !(i.colores && i.colores.length > 0) || !i.tipoImagen || !(i.file || i.name))) {
      this.snackService.error('Todas las imágenes deben tener tipo y color asociado.');
      return false;
    }*/

    return true;
  }

  async save(res) {

    if (res) {

      this.snackService.spinner(true);

      if (this.tipoTalle === '1') {
        this.producto.talles = [];
      }
      if (this.tipoTalle === '2') {
        this.producto.tallesNumericos = [];
      }

      if (this.producto.id) { // Update
        try {
          await await this.backendService.update(Producto.path + this.producto.id, this.producto);
          await this.saveImagenes(this.producto.id);
          await this.delay(600);
          this.snackService.success('Producto editado satisfactoriamente');
          this.router.navigate([Producto.path + 'detalles/' + this.producto.id]);
        } catch (ex) {
          if (ex[0]) {
            this.snackService.error(ex[0].details);
          } else if (ex.errors) {
            this.snackService.error(ex.errors[0].defaultMessage);
          } else {
            this.snackService.error(ex.message);
          }
        } finally {
          this.snackService.spinner(false);
        }
      } else {
        try {
          const response = await this.backendService.createWithResponse(Producto.path, this.producto);
          const clienteResponse = JSON.parse((response as Response).text());
          await this.saveImagenes(clienteResponse.id);
          if (this.rol.name == 'SELLER CENTER'){
            this.router.navigate(['/productos/por-proveedor']);
          }
          if (this.rol.name != 'SELLER CENTER'){
            this.router.navigate(['/productos']);
          }
          this.snackService.success('Producto creado satisfactoriamente');
        } catch (ex) {
          if (ex[0]) {
            this.snackService.error(ex[0].details);
          } else if (ex.errors) {
            this.snackService.error(ex.errors[0].defaultMessage);
          } else {
            this.snackService.error(ex.message);
          }
        } finally {
          this.snackService.spinner(false);
        }
      }
    }
  }
  async saveImagenes(productoId) {
    
    try {

      let formdata: FormData;
      const archivos = this.producto.imagenes;

      console.log(this.producto.imagenes)
      for (let i = 0; i < this.producto.imagenes.length; i++) {
        if (archivos[i].id === undefined && archivos[i].file !== null && archivos[i].file !== undefined) {
          formdata = new FormData();
          formdata.append('file', archivos[i].file);
          formdata.append('name', archivos[i].name);
          formdata.append('personalize', archivos[i].personalizable);
          formdata.append('id', productoId);
          //formdata.append('colorIds', archivos[i].colores.map(c => c.id).toString());
          //formdata.append('tipoImagenId', archivos[i].tipoImagen.id.toString());
          await this.backendService.createFile(Producto.newPath + "subir_imagen_personalizable", formdata);
        }
      }

    } catch (ex) {
      this.snackService.error(ex.message);
    }
  }

  delay(ms: number) {
    return new Promise( resolve => setTimeout(resolve, ms) );
  }

  compareFn(c1: any, c2: any): boolean {
    return c1 && c2 ? c1.id === c2.id : c1 === c2;
  }
  async seleccionarTodos() {
      await this.talles.subscribe(talles => {
        this.producto.talles = talles as Talle[];
      });
  }

  validarColores() {
    const usados = this.producto.imagenes.map(i => i.colores).reduce((a, b) => a.concat(b), []);
    const invalids = this.producto.colores.filter(c => !usados.find(u => u.id === c.id));

    return invalids.length === 0;
  }

  selectFile(event) {
    if (!event.target.files[0] || event.target.files[0].length == 0) {
      return;
    }
    var mimeType = event.target.files[0].type;
    //if (mimeType.match(/image\/*/) == null) {
    //  return;
    //}
    this.imagenFile = event.target.files[0];
    this.imagenesFile.push(this.imagenFile);
    this.producto.imagenes[0].file = this.imagenFile;
    console.log(this.producto);
    
  }

  async getUsuarioInternoProveedor(){
    await this.backendService.get(ProveedorSimple, Producto.newPath+ "proveedor_user/"+this.user.id).toPromise().then(a => {
      this.proveedorSimple = a as ProveedorSimple;
      this.producto.proveedor = this.proveedorSimple as Proveedor;
    })
  }

  async getRol(){
    await this.backendService.get(Role,"/new-roles/user/"+this.user.id).toPromise().then(a =>{
      this.rol = a as Role;
    });
    if (this.rol.name == 'SELLER CENTER'){
      this.getUsuarioInternoProveedor();
    }
  }

  async getIdPais(){
    await this.backendService.getPrecio("/usuarios_internos/get_usuario_pais").then(a =>{
      this.numberPaisId = a as number;
      } );    
      this.getNombrePais();
  }

  getNombrePais() {
    if (this.numberPaisId == 55) 
      this.nombrePais = 'ARGENTINA';
    else if (this.numberPaisId == 63){
      this.nombrePais = 'CHILE';
    }
    else if (this.numberPaisId == 0){
      this.nombrePais = 'AMBOS';
    }
  }

}


// WEBPACK FOOTER //
// ./src/app/productos/producto-add-edit/producto-add-edit.component.ts